import { Component, Input } from "@angular/core";
import { BaseComponent } from "../..";
import { CodePanelValuesModel } from "./codePanelValueModel";
import { ProductDataStore } from "../../providers/productData";
import { CodePanel } from "../../models";

@Component({
  selector: 'panel-codes-builder',
  templateUrl: './panelCodesBuilderComponent.html',
})
export class PanelCodesBuilderComponent extends BaseComponent {

  public calcVisible: boolean = false;
  public storedVisible: boolean = false;

  @Input()
  public showInlineTitle: boolean = false;

  public panelTitle: string;
  
  @Input()
  public valuesModel: CodePanelValuesModel

  constructor(public productStore: ProductDataStore) {
    super();
  }

  ngOnInit() {

    // Set the visibility

    this.storedVisible = !!this.valuesModel.values.find(x => x.storedValue != null);
    this.calcVisible = !!this.valuesModel.values.find(x => x.calcValue != null);

    let panel = this.productStore.getEntity<CodePanel>(this.valuesModel.panelId);

    this.panelTitle = panel.title;

  }
  
}